
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.378 1.62c2.084 0 3.773 1.728 3.773 3.859 0 1.098-.637 2.361-1.438 3.505h1.07a.6.6 0 01.469.225l2.717 3.41a.6.6 0 01-.469.973H2a.6.6 0 01-.47-.974L4.249 9.21a.6.6 0 01.47-.226l1.326.001c-.802-1.143-1.44-2.406-1.44-3.505 0-2.13 1.69-3.858 3.774-3.858zm-1.405 8.564H5.006l-1.76 2.208h10.008l-1.76-2.209h-1.71a19.703 19.703 0 01-1.406 1.5 20.152 20.152 0 01-1.405-1.5zm1.405-5.991c-.695 0-1.258.576-1.258 1.286 0 .71.563 1.286 1.258 1.286.694 0 1.257-.576 1.257-1.286a1.3 1.3 0 00-.368-.91 1.244 1.244 0 00-.89-.376z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    